<template>
  <div>
    <HeaderSection :relativeLinks="true" :fixed="true" :hideLogoOnMobile="true"></HeaderSection>
    <main>
      <HeroSection></HeroSection>
      <PhotoSection></PhotoSection>
      <FooterSection :layered="true"></FooterSection>
    </main>
  </div>
</template>

<script>
import HeaderSection from "@/components/HeaderSection.vue";
import HeroSection from "@/components/HeroSection.vue";
import PhotoSection from "@/components/PhotoSection.vue";
import FooterSection from "@/components/FooterSection.vue";

export default {
  name: "HomePage",
  components: {
    HeaderSection,
    HeroSection,
    PhotoSection,
    FooterSection,
  },
};
</script>

